import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';
import ClearIcon from '@material-ui/icons/Clear';
import { consts } from '../../common/consts'
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import googleImage from "../../assets/images/google.png";

export interface GooglePlaceAutoCompleteProps {
    inputValue?: string,
    onChange?(value: PlaceDetails | null): void,
    onInputChange?(value: string | null): void,
    singleLine?: boolean,
    hideNoOption?: boolean,
    value?: string,
    placeholder?: string,
    onBlur?(): void,
    name?: string
    error?: boolean,
    errorMessage?: string
}

function loadScript(src: string, position: HTMLElement | null, id: string, callback:() => void) {
    if (!position) {
        return;
    }

    const script = document.createElement('script');
    script.setAttribute('async', '');
    script.setAttribute('id', id);
    script.src = src;
    position.appendChild(script);
    script.addEventListener('load', function () {
        callback();
    });
}

const autocompleteService = { current: null };
const placesService = { current: null };

const useStyles = makeStyles((theme) => ({
    icon: {
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(2),
    },
    autoComplete: {
        '& .MuiAutocomplete-inputRoot': {
            padding: 0
        },
        '& .MuiAutocomplete-input': {
            padding: '0px 14px !important'
        },
        '& .MuiAutocomplete-clearIndicator': {
            padding: 0
        }
    },

    hide: {
        display: "none"
    },
    addressBlock: {
        '& .locality': {
            display: 'block'
        },
        '& .address_name': {
            fontWeight: 'bold',
           
        }
    }
}));

export interface PlaceType {
    description: string;
    place_id: string;
    structured_formatting: {
        main_text: string;
        secondary_text: string;
        main_text_matched_substrings: [
            {
                offset: number;
                length: number;
            },
        ];
    };
}



export interface PlaceDetails {
    address_components:AddressComponent[],
    lat: number,
    lng: number,
    name: string,
    adr_address: string,
    place_id: string,
    types: string[],
    vicinity: string,
    address_details: AddressDetails,
}

export interface AddressComponent {
    long_name: string,
    short_name: string,
    types: string[]
}

export interface AddressDetails {
    home: string,
    postal_code: string,
    street: string,
    region: string,
    city: string
    country: string
}

function timeout(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default function GooglePlaceAutoComplete(props: GooglePlaceAutoCompleteProps) {
    debugger
    const classes = useStyles();
    const [value, setValue] = React.useState<PlaceType | null>(null);
    const [inputValue, setInputValue] = React.useState('');
    const [options, setOptions] = React.useState<PlaceType[]>([]);
    const [selectedPlaceDetails, setSelectedPlaceDetails] = React.useState<PlaceDetails | null>(null);
    const loaded = React.useRef(false);

    const loadSelectedFromProps = async () => {
        if (!autocompleteService.current && (window as any).google) {         
            if((window as any).google.maps.places !== undefined)
            {
                autocompleteService.current = new (window as any).google.maps.places.AutocompleteService(document.createElement('div'));
      
            }
        }

        if (!placesService.current && (window as any).google) {
            if((window as any).google.maps.places !== undefined)
            {
            placesService.current = new (window as any).google.maps.places.PlacesService(document.createElement('div'));
            }
        }
        let waitCounter = 0;
        while ((!placesService.current || !autocompleteService.current) && waitCounter < 10) {
            await timeout(1000); // wait for google script been loaded
            waitCounter += 1
        }
        if (props.value !== '' && props.value !== null) {
            (placesService.current as any)?.getDetails({ placeId: props.value }, function (details: any, status: any) {

                let addressDetails = getAddressObject(details.address_components);

                const result: PlaceDetails = {
                    name: details.name,
                    address_components: Object.assign([], details.address_components),
                    adr_address: details.adr_address,
                    place_id: details.place_id,
                    types: Object.assign([], details.types),
                    lat: details.geometry.location.lat(),
                    lng: details.geometry.location.lng(),
                    vicinity: details.vicinity,
                    address_details: addressDetails
                };

                setSelectedPlaceDetails(result);
                if (props.onChange) {
                    props.onChange(result);
                }
            });
        }
    }

    const getAddressObject = (address_components: AddressComponent[]): AddressDetails => {
        let shouldBeComponent: {
            [index: string]: string[]

        } = {
            home: ["street_number"],
            postal_code: ["postal_code"],
            street: ["street_address", "route"],
            region: [
                "administrative_area_level_1",
                "administrative_area_level_2",
                "administrative_area_level_3",
                "administrative_area_level_4",
                "administrative_area_level_5"
            ],
            city: [
                "locality",
                "sublocality",
                "sublocality_level_1",
                "sublocality_level_2",
                "sublocality_level_3",
                "sublocality_level_4"
            ],
            country: ["country"]
        };

        let address:AddressDetails = {
            home: "",
            postal_code: "",
            street: "",
            region: "",
            city: "",
            country: ""
        };
        address_components.forEach(component => {
            for (var shouldBe in shouldBeComponent) {
                if (shouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                    switch (shouldBe) {
                        case 'home':
                            address.home = component.short_name;
                            break;
                        case 'street': 
                            address.street = component.short_name;
                            break;
                        case 'postal_code':
                            address.postal_code = component.short_name;
                            break;
                        case 'region':
                            address.region = component.short_name;
                            break;
                        case 'city':
                            address.city = component.short_name;
                            break;
                        case 'country':
                            address.country = component.long_name;
                            break;
                    }
                }
            }
        });
        return address;
    }
 

    if (typeof window !== 'undefined' && !loaded.current) {
       
        if (!document.querySelector('#google-maps-script')) {
            loadScript(
                "https://maps.googleapis.com/maps/api/js?key=" + consts.GooglePlaceAPIKey + "&libraries=places",
                document.querySelector('head'),
                'google-maps-script', () => {
                    loadSelectedFromProps();
                }
            );
        }
        else {
            if (!autocompleteService.current && (window as any).google) {
                if((window as any).google.maps.places !== undefined)
                {
                autocompleteService.current = new (window as any).google.maps.places.AutocompleteService(document.createElement('div'));
                }
            }

            if (!placesService.current && (window as any).google) {
                if((window as any).google.maps.places !== undefined)
                {
                placesService.current = new (window as any).google.maps.places.PlacesService(document.createElement('div'));
                }
            }
            loadSelectedFromProps();
        }

        loaded.current = true;
    }
   

    const fetch = React.useMemo(
        () =>
            throttle((request: { input: string, componentRestrictions: { country: string[] }, types: ["street_address", "premise", "health", "subpremise"] }, callback: (results?: PlaceType[]) => void) => {
                (autocompleteService.current as any).getPlacePredictions(request, callback);
            }, 200),
        [],
    );
    React.useEffect(() => {
        loadSelectedFromProps();
    }, [ props.value ])

    React.useEffect(() => {
        let active = true;

        if (!autocompleteService.current && (window as any).google) {
            if((window as any).google.maps.places !== undefined)
            {
            autocompleteService.current = new (window as any).google.maps.places.AutocompleteService(document.createElement('div'));
            }
        }

        if (!placesService.current && (window as any).google) {
            if((window as any).google.maps.places !== undefined)
            {
            placesService.current = new (window as any).google.maps.places.PlacesService(document.createElement('div'));
            }
        }
        if (!autocompleteService.current || !placesService.current) {
            return undefined;
        }

        if (inputValue === '') {
            setOptions(value ? [value] : []);
            return undefined;
        }
        

        fetch({ input: inputValue, componentRestrictions: { country: ['au'] }, types: ["street_address", "premise", "health", "subpremise"]  }, (results?: PlaceType[]) => {
            if (active) {
                let newOptions = [] as PlaceType[];

                if (value) {
                    newOptions = [value];
                }

                if (results) {
                    console.log("results", results)
                    newOptions = [...newOptions, ...results];
                }

                setOptions(newOptions);
            }
        });
      
        return () => {
            active = false;
        };
    }, [value, inputValue, fetch]);

  
    const renderAutoComplete = () => {
        if (selectedPlaceDetails != null && !props.singleLine) {
            return <div style={{
                display: 'inline-flex',
                position: 'relative',
                minHeight: 110,
                width: '100%',
                borderRadius: 4,
                backgroundColor: '#ECECEC'
            }}>

                <div style={{ flexGrow: 1, fontSize: 18, padding: '6px 14px' }} className={classes.addressBlock}>
                    <span className='address_name' style={{ display: selectedPlaceDetails.types !== null && selectedPlaceDetails.types.indexOf('establishment') > -1 ? 'block' : 'none' }}>{selectedPlaceDetails.name}</span>
                    <div>
                        <span style={{ display: 'block' }}>{selectedPlaceDetails.address_details.home} {selectedPlaceDetails.address_details.street}</span>
                        <span style={{ display: 'block' }}>{selectedPlaceDetails.address_details.city}</span>
                        <span>{selectedPlaceDetails.address_details.region}, {selectedPlaceDetails.address_details.postal_code}</span>
                    </div>
                </div>
                <div style={{
                    marginTop: 12,
                    marginRight:13
                }}>
                    <IconButton aria-label="clear" style={{ fontSize: 14, padding: 0 }} 
                        onClick={() => { 
                            setValue(null); 
                            setInputValue("")
                            setSelectedPlaceDetails(null); 
                            if (props.onChange) { 
                                props.onChange(null); 
                            } 
                        }}
                    >
                        <ClearIcon />
                    </IconButton>
                </div>
            </div>
        }
        else {
            return <Autocomplete
                id={props.name}
                popupIcon={null}
                className={classes.autoComplete}
                classes={props.hideNoOption ? { noOptions: classes.hide } : {} }
                getOptionLabel={(option) => (

                    typeof option === 'string' ?
                        option :
                        option.structured_formatting.main_text + '\r\n'
                        + option.structured_formatting.secondary_text
                )}

                filterOptions={(x) => x}
                options={options}
                autoComplete
                freeSolo={props.singleLine ? true : false}
                includeInputInList
                filterSelectedOptions
                value={value}
                onChange={(event: any, newValue: any) => {
                    if (!props.singleLine) setOptions(newValue ? [newValue, ...options] : options);
                    if (!props.singleLine) setValue(newValue);
                    if (newValue !== null) {
                        (placesService.current as any)?.getDetails({ placeId: newValue?.place_id }, function (details: any, status: any) {
                            let addressDetails = getAddressObject(details.address_components);
                            const result: PlaceDetails = {
                                name: details.name,
                                address_components: Object.assign([], details.address_components),
                                adr_address: details.adr_address,
                                place_id: details.place_id,
                                types: Object.assign([], details.types),
                                lat: details.geometry.location.lat(),
                                lng: details.geometry.location.lng(),
                                vicinity: details.vicinity,
                                address_details: addressDetails
                            };

                            setSelectedPlaceDetails(result);
                            if (props.onChange) {
                                props.onChange(result);
                            }
                            if (props.singleLine) {
                                let fullAddress = '';
                                if (result.types.indexOf('establishment') > -1) {
                                    fullAddress += result.name ? result.name + ', ' : '';
                                }
                                fullAddress += result?.address_details?.home ? result?.address_details?.home + ' ' : '';
                                fullAddress += result?.address_details?.street ? result?.address_details?.street + ', ' : '';
                                fullAddress += result?.address_details?.city ? result?.address_details?.city + ', ' : '';
                                fullAddress += result?.address_details?.region ? result?.address_details?.region + ', ' : '';
                                fullAddress += result?.address_details?.postal_code ? result?.address_details?.postal_code : '';
                                if (props.onInputChange) {
                                    props.onInputChange(fullAddress);
                                }
                            }
                        });
                    }
                   
                }}
                inputValue={props.inputValue || inputValue}
                onInputChange={(event, newInputValue) => {
                    if (event !== null) {
                        setInputValue(newInputValue);
                        if (props.onInputChange) {
                            props.onInputChange(newInputValue);
                        }
                    }
                }}
                renderInput={(params) => (
                    //@ts-ignore
                    <TextField {...params} inputProps={Object.assign({ readOnly: value !== null, autoComplete: !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) ? "chrome-off" : "off" }, params.inputProps)} variant="outlined" placeholder={props.placeholder} onBlur={props.onBlur} error={props.error} helperText={props.errorMessage} />

                )
                }
                PaperComponent={CustomPaper}
                renderOption={(option) => {
                    const matches = option.structured_formatting.main_text_matched_substrings;
                    const parts = parse(
                        option.structured_formatting.main_text,
                        matches.map((match: any) => [match.offset, match.offset + match.length]),
                    );

                    return (
                        <Grid container alignItems="center">
                            <Grid item>
                                <LocationOnIcon className={classes.icon} />
                            </Grid>
                            <Grid item xs>
                                {parts.map((part, index) => (
                                    <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                        {part.text}
                                    </span>
                                ))}
                                <Typography variant="body2" color="textSecondary">
                                    {option.structured_formatting.secondary_text}
                                </Typography>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        }
    }
    return (
        <React.Fragment>
            {renderAutoComplete()}
        </React.Fragment>
    );
}
const CustomPaper = (props: any) => {
    let hasResult = props.children.every((item: any) => item === null);  
    console.log(hasResult);  
    return (  
      <Paper elevation={hasResult ? 0 : 10}>  
        <Paper elevation={0} {...props} />  
        {!hasResult && (  
          <Box  
            display={"flex"}  
            alignItems={"center"}  
            justifyContent={"flex-end"}  
            style={{ paddingRight: "25px", paddingBottom: "15px", gap: 5 }}  
          >  
            <Typography align="right">Powered by</Typography>  
            <img  
              src={googleImage}  
              alt="google"  
              width={50}  
              height={20}  
              style={{ marginTop: 5 }}  
            />  
          </Box>
          )}
          </Paper>      
        );      
      };